import { DefaultLegendContentProps, LegendProps } from 'recharts';
import { Box, BoxProps } from '@mui/material';

import { PiePieceItem } from './pie-chart.types';

import { Typography } from '../typography';
import { Tooltip } from '../tooltip';

type BuildRenderLegendParams = {
  wrapperProps?: BoxProps;
  totalValue: number;
};
export const buildRenderLegend = ({
  wrapperProps,
  totalValue,
}: BuildRenderLegendParams): LegendProps['content'] => {
  return (props: DefaultLegendContentProps) => {
    const { payload = [] } = props;

    return (
      <Box display='grid' gridTemplateColumns='repeat(1, 1fr)' rowGap={2} {...wrapperProps}>
        {payload.map((item, index) => {
          // value and name are present inside payload but recharts doesn't provide generic TS type
          // This why we have to do type assertion here
          const { value, name } = item.payload as unknown as PiePieceItem;
          const percentage = totalValue > 0 ? (value * 100) / totalValue : 0;

          return (
            <Box
              key={`${index}-${name}`}
              display='flex'
              alignItems='center'
              gap={1}
              overflow='hidden'
            >
              <Box width={16} height={16} bgcolor={item.color} borderRadius={1} flexShrink={0} />

              <Typography variant='subtitle2'>{value}</Typography>

              <Typography variant='body2' color='text.disabled'>
                ({percentage.toFixed(0)}%)
              </Typography>

              <Tooltip title={name}>
                <Typography
                  variant='body2'
                  whiteSpace='nowrap'
                  overflow='hidden'
                  textOverflow='ellipsis'
                >
                  {name}
                </Typography>
              </Tooltip>
            </Box>
          );
        })}
      </Box>
    );
  };
};
